import { type FC } from 'react';
import { Col, Row } from 'react-bootstrap';
import AttributeImg from '../ProductAttribute/AttributeImg/AttributeImg';
import AttributeBrandName from '../ProductAttribute/AttributeBrandName/AttributeBrandName';
import FlavourName from '../ProductAttribute/FlavourName/FlavourName';
import AttributeAvailability from '../ProductAttribute/AttributeAvailability/AttributeAvailability';
import QuantityOrNotify from '../../../../ProductAttribute/QuantityOrNotify/QuantityOrNotify';
import AttributePrice from '../ProductAttribute/AttributePrice/AttributePrice';
import { ProductAttributeDisplayPropsT } from '../ProductAttribute/ProductAttribute';
import { useProductsFilter } from '../../../../../Context/ProductsFilterContext';
import styles from './ProductAttributeDesktop.module.scss?module';
import LoginButtonSpan from '../../../../LoginButtonSpan/LoginButtonSpan';
import clsx from 'clsx';
import QuickViewButton from '../ProductAttribute/components/QuickViewButton/QuickViewButton';

const ProductAttributeDesktop: FC<ProductAttributeDisplayPropsT> = ({
  attribute,
  isClearance,
  user,
  getAttributeImages,
  onShowQuickView,
  allowBackorder = false,
}) => {
  const { filters } = useProductsFilter();

  if (filters.view === 'table') {
    return (
      <div className={styles.TableRow}>
        <div className={styles.Brand}>
          <AttributeBrandName
            view={filters.view}
            attribute={attribute}
            isNew={attribute.product_size?.is_new}
          />
        </div>

        <div className={styles.Product}>
          <FlavourName
            view={filters.view}
            isClearance={isClearance}
            productSizeName={attribute.product_size.name}
            combinedDescription1={attribute.combined_description_1}
          />
        </div>

        <div className={styles.Variant}>
          <AttributeAvailability
            view={filters.view}
            user={user}
            attributeName={attribute.name}
            attributeEta={attribute.eta}
            hasStock={attribute.has_stock}
            allowBackorder={allowBackorder}
          />
        </div>
        <div className={styles.Actions}>
          <QuickViewButton
            onShowQuickView={() => onShowQuickView(attribute.id)}
          />
        </div>
        <div className={clsx(styles.Price)}>
          <AttributePrice attribute={attribute} />
        </div>

        {user?.id ? (
          <div className={styles.Qty}>
            <div className={styles.QtyInner}>
              <QuantityOrNotify
                product_attribute={attribute}
                price={attribute.product_size?.price ?? 0}
                combined_price={attribute.product_size?.combined_price}
                allowBackorder={allowBackorder}
              />
            </div>
          </div>
        ) : (
          <LoginButtonSpan className={styles.LoginButtonSpan} />
        )}
      </div>
    );
  }

  return (
    <>
      <Row className="py-3 mx-0">
        {/* img */}
        {filters.view === 'list' ? (
          <Col xs={1} className="my-auto px-0 px-xxl-2">
            <AttributeImg
              img={attribute.image_white_public_url}
              name={attribute.name}
              onClick={() => getAttributeImages(attribute.id)}
              isNew={attribute.product_size?.is_new}
              imageOverlayUri={attribute.product_size?.image_overlay_uri}
              isDeposit={
                attribute.product_size?.single_deposit_price > 0 &&
                attribute.product_size?.deposit_units_count > 0
              }
            />
          </Col>
        ) : null}

        {/* brand name */}
        <Col xs={2} className="my-auto text-14">
          <AttributeBrandName
            view={filters.view}
            attribute={attribute}
            isNew={attribute.product_size?.is_new}
          />
        </Col>

        {/* flavour name */}
        <Col xs={2} xxl={3} className="my-auto text-14">
          <FlavourName
            view={filters.view}
            isClearance={isClearance}
            productSizeName={attribute.product_size.name}
            combinedDescription1={attribute.combined_description_1}
          />
        </Col>

        {/* aviliblity  */}
        <Col xs={2} className="my-auto text-14">
          <AttributeAvailability
            view={filters.view}
            user={user}
            attributeName={attribute.name}
            attributeEta={attribute.eta}
            hasStock={attribute.has_stock}
            allowBackorder={allowBackorder}
          />
        </Col>

        <Col className="my-auto text-end ps-0">
          <QuickViewButton
            onShowQuickView={() => onShowQuickView(attribute.id)}
          />
        </Col>

        {user?.id ? (
          <>
            {/* price */}
            <Col xs={2} className="ps-0 my-auto text-end">
              <AttributePrice attribute={attribute} />
            </Col>

            {/* Qn input */}
            <Col className="my-auto pe-0">
              <div className={styles.QtyInner}>
                <QuantityOrNotify
                  product_attribute={attribute}
                  price={attribute.product_size?.price ?? 0}
                  combined_price={attribute.product_size?.combined_price}
                  allowBackorder={allowBackorder}
                />
              </div>
            </Col>
          </>
        ) : (
          <>
            {/* Clearance-/Promo-Störer auch für ausgeloggte Nutzer – ohne Preis (P-4877, Punkt 1) */}
            <Col xs={2} className="ps-0 my-auto text-end">
              <AttributePrice attribute={attribute} showPrice={false} />
            </Col>
            {/* LoginButton */}
            <Col className={clsx('my-auto', !user?.id && 'pe-0')}>
              <div className="d-flex gap-2 justify-content-end align-items-center">
                <LoginButtonSpan className={styles.LoginButtonSpan} />
              </div>
            </Col>
          </>
        )}
      </Row>
    </>
  );
};

export default ProductAttributeDesktop;
